function postAjax(url, data, callback) {
    let userLang = document.documentElement.lang;
    console.log(userLang, data);
    if(data && typeof data == 'node')
      data.append('userLang', userLang);
  $.ajax({
        traditional: true,
        type: 'POST',
        url: url,
        data: data,
        dataType: 'json',
        //contentType: false,
        //processData: false
    })
        .done((data) => {
            callback(data)
        })
        .fail(function (jqXHR, textStatus, errorThrown) {
            console.log('internal server error on update settings')
        });
}

function postAjaxFile(url, data, callback) {
  let userLang = document.documentElement.lang;
  data.append('userLang', userLang);
  $.ajax({
    traditional: true,
    type: 'POST',
    url: url,
    data: data,
    //dataType: 'json',
    contentType: false,
    processData: false
  })
    .done((data) => {
      callback(data)
    })
    .fail(function (jqXHR, textStatus, errorThrown) {
      console.log('internal server error on update settings')
    });
}

function postAjaxFormData(url, data, callback) {
    let userLang = document.documentElement.lang;
    if(data && typeof data == 'node')
      data = data + '&userLang=' + userLang;
    console.log(userLang, data);
  $.ajax({
        traditional: true,
        type: 'POST',
        url: url,
        data: data,
        dataType: 'json',
        //contentType: false,
        //processData: false
    })
        .done((data) => {
            callback(data)
        })
        .fail(function (jqXHR, textStatus, errorThrown) {
            console.log('internal server error on update settings')
        });
}



export { postAjax, postAjaxFormData, postAjaxFile };
